import $ from 'jquery';
import ProductOptions from './ProductOptions';

export default class VariantHelper {
  constructor(product, $variants, $options) {
    this.product = product;
    this.optionsCount = this.product.options.length;
    this.$variants = $variants;
    this.$options = $options;
    this.productOptions = new ProductOptions(this.product);
    this.optionsTypes = {
      select: 'select',
      radio: 'input[type="radio"]',
    };

    this._bindEvents();

    if (this.$options.is(this.optionsTypes.select)) {
      this.optionsType = this.optionsTypes.select;
    } else if (this.$options.is(this.optionsTypes.radio)) {
      this.optionsType = this.optionsTypes.radio;
    } else {
      console.warn('Variant helper: Option set is not a valid type');
      this._unbindEvents();
    }

    this._switchVariant(true);
  }

  _bindEvents() {
    this.$options.on('change.variant-helper', () => this._switchVariant());
  }

  _unbindEvents() {
    this.$options.off('change.variant-helper');
  }

  _switchVariant(firstLoad = false) {
    const options = [];
    const product = this.product;
    let variant = null;
    let availableOptions = null;

    if (this.optionsType === this.optionsTypes.select) {
      this.$options.each((i, option) => {
        options.push(option.value);
      });
    } else if (this.optionsType === this.optionsTypes.radio) {
      this.$options.filter(':checked').each((i, option) => {
        options.push(option.value);
      });
    } else {
      return;
    }

    variant = this.productOptions.getVariantOrClosestFromOptions(options);

    if (variant) {
      availableOptions = this.productOptions.getAvailableOptionsFromVariant(variant);
    } else {
      return;
    }

    if (this.optionsType === this.optionsTypes.select) {
      this._switchVariantSelect(variant, availableOptions);
    } else if (this.optionsType === this.optionsTypes.radio) {
      this._switchVariantRadio(variant, availableOptions);
    } else {
      return;
    }

    this.$variants.val(variant.id);

    // This function can be used by the event handler to determine if this
    // VariantHelper instance handles a specific product instance
    const isProduct = compareProduct => compareProduct === product;
    $(window).trigger('product-variant-switch', { product, variant, firstLoad, isProduct });
  }

  _switchVariantSelect(variant, availableOptions) {
    // Iterate over each option type
    for (let i = 0; i < this.product.options.length; i++) {
      // Corresponding select dropdown
      const $select = $(this.$options[i]);
      const $optionEls = $select.find('option');

      // Iterate over each option on dropdown
      $optionEls.each((index, option) => {
        const $option = $(option);
        const value = option.value;

        // Not an available option
        $option
          .prop('disabled', (!availableOptions[i][value] || !availableOptions[i][value].available))
          .prop('selected', false);

        // Dropdown option matches variant option
        if (variant.options[i] === value) {
          $option
            .prop('disabled', false)
            .prop('selected', true);
        }
      });
    }
  }

  _switchVariantRadio(variant, availableOptions) {
    this.$options
      .attr('disabled', true)
      .prop('checked', false)
      .attr('data-soldout', false);

    for (let i = 0; i < this.product.options.length; i++) {
      const selector = encodeURIComponent(this.product.options[i])
        .replace(/%20/g, "+")
        .replace(/[!'()*]/g, char => { return '%' + char.charCodeAt(0).toString(16).toUpperCase(); });

      const $options = this.$options.filter(`[name="${selector}"]`);
      $options.each((index, option) => {
        const $option = $(option);

        if (variant.options[i] === $option.val()) {
          $option
            .prop('checked', true);
        }

        if (availableOptions[i][$option.val()]) {
          $option.attr('disabled', false);

          if (!availableOptions[i][$option.val()].available) {
            $option.attr('disabled', true);
            $option.attr('data-soldout', true);
          }
        }
      });
    }
  }

  isDefault() {
    if (this.product.variants[0].title === 'Default Title' && this.product.variants[0].option1 === 'Default Title') {
      return true;
    }

    return false;
  }

  hasSingleOption() {
    return this.optionsCount === 1;
  }

  getSelectedVariant() {
    if (this.isDefault()) {
      return this.product.variants[0];
    }

    const options = [];

    if (this.optionsType === this.optionsTypes.select) {
      this.$options.each((i, option) => {
        options.push(option.value);
      });
    } else if (this.optionsType === this.optionsTypes.radio) {
      this.$options.filter(':checked').each((i, option) => {
        options.push(option.value);
      });
    } else {
      return null;
    }

    return this.productOptions.getVariantFromOptions(options);
  }

  unload() {
    this._unbindEvents();
  }
}
